import { Command } from "./index";
import { Icon } from "@chakra-ui/react";
import { MdCircle } from "react-icons/md";
import { insertSurroundingText } from "../utils/insertSurroundingText";
import { convertGameMakerColourToHex } from "../../../utils/convertGameMakerColourToHex";

export const colourMagenta: Command = {
  category: "colour",
  icon: <Icon as={MdCircle} />,
  name: `#${convertGameMakerColourToHex(16711935)}`,
  tooltip: "colour as magenta",
  execute: (editorRef) => insertSurroundingText(editorRef, "{{#colourMagenta}}", "{{/colourMagenta}}"),
};
